export const OPERATIONS_PALETTES = {
  light: {
    text: "#163453",
    heading: "#122b4d",
    muted: "#536b84",
    surface: "#ffffff",
    canvas: "#f2f6fb",
    canvasEnd: "#edf3f9",
    subtle: "#f4f7fb",
    nav: "#e7eff8",
    hover: "#edf5ff",
    selected: "#e1ecf8",
    border: "#dce6f1",
    inputBorder: "#cedcee",
    accent: "#1169d0",
    primary: "#1676e8",
    primaryHover: "#1166ca",
    onPrimary: "#ffffff",
    focus: "#76acf0",
    success: "#0b7741",
    successBg: "#e6f7ec",
    warning: "#8d5404",
    warningBg: "#fff1d6",
    danger: "#bf3547",
    dangerBg: "#ffeaed",
    info: "#1269d2",
    infoBg: "#e6f0ff",
    attention: "#fff8e9",
    attentionBorder: "#f1d499",
    track: "#eaf0f8",
    chartStrong: "#174c8c",
    chartMedium: "#5ca2e8",
    chartLight: "#b8dcf5",
    chartRed: "#d93636",
    chartGreen: "#19a779",
    chartGold: "#ac8437",
    chartSlate: "#91a2b5",
    chartTeal: "#67939b",
    chartSand: "#cfb86e",
    chartFillMedium: "#95abc6",
    chartFillLight: "#e4d5a7",
    onChart: "#163453",
    onChartStrong: "#ffffff",
  },
  dark: {
    text: "#dce7f5",
    heading: "#eef3ff",
    muted: "#a8bad0",
    surface: "#111b2e",
    canvas: "#0b1220",
    canvasEnd: "#101929",
    subtle: "#182438",
    nav: "#17263c",
    hover: "#223751",
    selected: "#233e60",
    border: "#30435e",
    inputBorder: "#46617f",
    accent: "#83bcff",
    primary: "#1676e8",
    primaryHover: "#1166ca",
    onPrimary: "#ffffff",
    focus: "#9acaff",
    success: "#78d8a5",
    successBg: "#143829",
    warning: "#ffd080",
    warningBg: "#3c301b",
    danger: "#ff9caa",
    dangerBg: "#40232e",
    info: "#99c7ff",
    infoBg: "#193452",
    attention: "#30291c",
    attentionBorder: "#725c37",
    track: "#263851",
    chartStrong: "#75b0ef",
    chartMedium: "#98c7f4",
    chartLight: "#c6def4",
    chartRed: "#ff8d99",
    chartGreen: "#66d1a5",
    chartGold: "#e6bd6d",
    chartSlate: "#adbed3",
    chartTeal: "#97c6ce",
    chartSand: "#dec991",
    chartFillMedium: "#95abc6",
    chartFillLight: "#e4d5a7",
    onChart: "#10243d",
    onChartStrong: "#10243d",
  },
};

export function getOperationsVariables(mode) {
  const palette = OPERATIONS_PALETTES[mode === "dark" ? "dark" : "light"];
  return Object.fromEntries(
    Object.entries(palette).map(([name, value]) => [
      `--ops-${name.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`)}`,
      value,
    ]),
  );
}

export const chartTooltipProps = {
  contentStyle: {
    background: "var(--ops-surface)",
    border: "1px solid var(--ops-border)",
    borderRadius: 8,
    color: "var(--ops-text)",
  },
  labelStyle: { color: "var(--ops-heading)" },
  cursor: { fill: "var(--ops-subtle)", stroke: "var(--ops-border)" },
};
